import { ReactElement } from "react";
import { Tooltip as ToolTipComponent } from "antd";

export default function Tooltip({
  children,
  content,
  placement = "left",
}: {
  children: ReactElement;
  content?: ReactElement | string;
  placement?:
    | "top"
    | "left"
    | "right"
    | "bottom"
    | "topLeft"
    | "topRight"
    | "bottomLeft"
    | "bottomRight"
    | "leftTop"
    | "leftBottom"
    | "rightTop"
    | "rightBottom";
}) {
  return (
    <ToolTipComponent
      title={content}
      trigger={["click", "hover", "focus"]}
      placement={placement}
    >
      {children}
    </ToolTipComponent>
  );
}
